// Auth Types
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT = 'LOGOUT';
export const GET_PROFILE_REQUEST = 'GET_PROFILE_REQUEST';
export const GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS';
export const GET_PROFILE_FAILURE = 'GET_PROFILE_FAILURE';

// Book Types
export const FETCH_SONG_MODELS_REQUEST = 'FETCH_SONG_MODELS_REQUEST';
export const FETCH_SONG_MODELS_SUCCESS = 'FETCH_SONG_MODELS_SUCCESS';
export const FETCH_SONG_MODELS_FAILURE = 'FETCH_SONG_MODELS_FAILURE';
export const ADD_SONG_MODEL_REQUEST = 'ADD_SONG_MODEL_REQUEST';
export const ADD_SONG_MODEL_SUCCESS = 'ADD_SONG_MODEL_SUCCESS';
export const ADD_SONG_MODEL_FAILURE = 'ADD_SONG_MODEL_FAILURE';
export const UPDATE_SONG_MODEL_REQUEST = 'UPDATE_SONG_MODEL_REQUEST';
export const UPDATE_SONG_MODEL_SUCCESS = 'UPDATE_SONG_MODEL_SUCCESS';
export const UPDATE_SONG_MODEL_FAILURE = 'UPDATE_SONG_MODEL_FAILURE';
export const DELETE_SONG_MODEL_REQUEST = 'DELETE_SONG_MODEL_REQUEST';
export const DELETE_SONG_MODEL_SUCCESS = 'DELETE_SONG_MODEL_SUCCESS';
export const DELETE_SONG_MODEL_FAILURE = 'DELETE_SONG_MODEL_FAILURE';

// Category Types
export const FETCH_CATEGORIES_REQUEST = 'FETCH_CATEGORIES_REQUEST';
export const FETCH_CATEGORIES_SUCCESS = 'FETCH_CATEGORIES_SUCCESS';
export const FETCH_CATEGORIES_FAILURE = 'FETCH_CATEGORIES_FAILURE';
export const ADD_CATEGORY_REQUEST = 'ADD_CATEGORY_REQUEST';
export const ADD_CATEGORY_SUCCESS = 'ADD_CATEGORY_SUCCESS';
export const ADD_CATEGORY_FAILURE = 'ADD_CATEGORY_FAILURE';
export const UPDATE_CATEGORY_REQUEST = 'UPDATE_CATEGORY_REQUEST';
export const UPDATE_CATEGORY_SUCCESS = 'UPDATE_CATEGORY_SUCCESS';
export const UPDATE_CATEGORY_FAILURE = 'UPDATE_CATEGORY_FAILURE';
export const DELETE_CATEGORY_REQUEST = 'DELETE_CATEGORY_REQUEST';
export const DELETE_CATEGORY_SUCCESS = 'DELETE_CATEGORY_SUCCESS';
export const DELETE_CATEGORY_FAILURE = 'DELETE_CATEGORY_FAILURE';